import { render, staticRenderFns } from "./baseChartList.vue?vue&type=template&id=212d1402"
import script from "./baseChartList.vue?vue&type=script&lang=ts"
export * from "./baseChartList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports